import { render, staticRenderFns } from "./NodeTableColumnsForm.vue?vue&type=template&id=b216180a"
import script from "./NodeTableColumnsForm.vue?vue&type=script&lang=js"
export * from "./NodeTableColumnsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports